export default __webpack_public_path__ + "static/media/detail_mobile_16_1.96a976e9.jpg";